import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PipeModule } from '@app/shared';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { GoalLineGoalComponent } from './line-goal.component';
import { IconComponent } from '@app/tw-shared/components';
import { BarComponent } from '@app/tw-shared/components/bar/components/bar.component';

@NgModule({
    imports: [CommonModule, TranslateModule, InlineSVGModule, NgbTooltipModule, PipeModule, IconComponent, BarComponent],
    declarations: [GoalLineGoalComponent],
    exports: [GoalLineGoalComponent],
})
export class GoalLineGoalModule {}
